import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';
import { validateRedirectUrl } from '@/lib/redirect';
import { PERMISSIONS } from '@/constants/permissions';

/**
 * Seven screens, in the order the data model reads: what to run, what
 * authenticates it, what exists, then the two observability screens and the
 * destructive one last.
 *
 * createWebHistory, so src/routes.py needs a catch-all returning index.html
 * for any non-/api path.
 */
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: { public: true },
      component: () => import('@/shell/Login.vue'),
    },
    {
      path: '/',
      component: () => import('@/shell/AppShell.vue'),
      children: [
        { path: '', name: 'fleet', component: () => import('@/views/FleetView.vue') },
        { path: 'groups', name: 'groups', component: () => import('@/views/GroupsView.vue') },
        { path: 'accounts', name: 'accounts', component: () => import('@/views/AccountsView.vue') },
        { path: 'nodes', name: 'nodes', component: () => import('@/views/NodesView.vue') },
        { path: 'pools', name: 'pools', component: () => import('@/views/PoolsView.vue') },
        { path: 'reconciler', name: 'reconciler', component: () => import('@/views/ReconcilerView.vue') },
        { path: 'operations', name: 'operations', component: () => import('@/views/OperationsView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

router.beforeEach((to) => {
  if (to.meta.public) return true;

  const auth = useAuthStore();
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: validateRedirectUrl(to.fullPath) ?? undefined } };
  }

  // A session minted before the permission existed: log out rather than
  // letting every request 403.
  if (!auth.hasPermission(PERMISSIONS.ACCESS)) {
    auth.logout();
    return { name: 'login' };
  }

  return true;
});

export default router;
